'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useDataStore } from '../store';

const DataProvider = ({ children, newData, lang }) => {
	const pathname = usePathname();
	const previousRef = useRef();

	const setInitialData = useDataStore((state) => state.setInitialData);
	const setPrevRoute = useDataStore((state) => state.setPrevRoute);

	useEffect(() => {
		setInitialData({ newData, lang });
	}, [newData, lang, setInitialData]);

	useEffect(() => {
		if (previousRef.current && previousRef.current !== pathname) {
			setPrevRoute(previousRef.current);
		}

		previousRef.current = pathname;
	}, [pathname, setPrevRoute]);

	return children;
};

export default DataProvider;
